// src/graphql/mutations/resetPassword.js
import { gql } from '@apollo/client';

export const RESET_PASSWORD_MUTATION = gql`
  mutation resetPassword($username: AWSEmail!, $verification_code: String!, $new_password: String!) {
    resetPassword(username: $username, verification_code: $verification_code, new_password: $new_password) {
      result
    }
  }
`;